import { render } from "./AdminUploadAdMediaForm.vue?vue&type=template&id=bf736922"
import script from "./AdminUploadAdMediaForm.vue?vue&type=script&lang=js"
export * from "./AdminUploadAdMediaForm.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/laravel/sundae-scoops/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__